import { isEmpty } from "lodash";
import type { SaleDataType } from "../../models/sale";

/**
 * Uplifted from `apps/web/src/helper/customerAndDeliveryInfoValidation` — web's body, and the ONE
 * body: mobile had only the thinner `customerAndDeliveryInfoValidation` (empty delivery/customer
 * info), so the payment engine's two hosts posted different sale bodies (docs/flows/PAYMENT_ENGINE.md
 * §37 M2). Seeded with this symbol only; the app files keep their own
 * `customerAndDeliveryInfoValidation` until a consumer needs it here.
 *
 * validate sale data using this function before sending to BE
 * @param saleData
 * @returns validated saleData
 */
export const validateSaleData = (saleData: SaleDataType) => {
  const saleDataClone: any = structuredClone(saleData);
  if (isEmpty(saleDataClone.deliveryInfo)) {
    delete saleDataClone.deliveryInfo;
  }
  if (isEmpty(saleDataClone.customerInfo)) {
    delete saleDataClone.customerInfo;
  }
  if (saleDataClone.customerInfo && !saleDataClone.customerInfo?.customerId && !saleDataClone.customerInfo?.customerRefId) {
    delete saleDataClone.customerInfo;
  }
  if (isEmpty(saleDataClone.billHeader)) {
    delete saleDataClone.billHeader;
  }
  if (isEmpty(saleDataClone.serviceLabel)) {
    delete saleDataClone.serviceLabel;
  }
  if (isEmpty(saleDataClone.saleBy)) {
    delete saleDataClone.saleBy;
  }
  if (isEmpty(saleDataClone.updatedBy)) {
    delete saleDataClone.updatedBy;
  }
  if (isEmpty(saleDataClone.modifiedBy)) {
    delete saleDataClone.modifiedBy;
  }
  saleDataClone.saleItems?.forEach((item: any) => {
    if (item?.isNewItem) delete item.isNewItem;
  });
  saleDataClone.saleValidated = true;
  return saleDataClone;
};
